/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class NFTFinalSubscription {
    'id'?: number;
    'consolidation_key': string;
    'contract': string;
    'token_id': number;
    'subscribed_count': number;
    'airdrop_address': string;
    'balance': number;
    'subscribed_at'?: string | null;
    'phase'?: string | null;
    'phase_subscriptions'?: number;
    'phase_position'?: number;
    'redeemed_count'?: number;
    'created_at'?: Date;
    'updated_at'?: Date;

    static readonly discriminator: string | undefined = undefined;

    static readonly mapping: {[index: string]: string} | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "id",
            "baseName": "id",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "consolidation_key",
            "baseName": "consolidation_key",
            "type": "string",
            "format": ""
        },
        {
            "name": "contract",
            "baseName": "contract",
            "type": "string",
            "format": ""
        },
        {
            "name": "token_id",
            "baseName": "token_id",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "subscribed_count",
            "baseName": "subscribed_count",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "airdrop_address",
            "baseName": "airdrop_address",
            "type": "string",
            "format": ""
        },
        {
            "name": "balance",
            "baseName": "balance",
            "type": "number",
            "format": "double"
        },
        {
            "name": "subscribed_at",
            "baseName": "subscribed_at",
            "type": "string",
            "format": ""
        },
        {
            "name": "phase",
            "baseName": "phase",
            "type": "string",
            "format": ""
        },
        {
            "name": "phase_subscriptions",
            "baseName": "phase_subscriptions",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "phase_position",
            "baseName": "phase_position",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "redeemed_count",
            "baseName": "redeemed_count",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "created_at",
            "baseName": "created_at",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "updated_at",
            "baseName": "updated_at",
            "type": "Date",
            "format": "date-time"
        }    ];

    static getAttributeTypeMap() {
        return NFTFinalSubscription.attributeTypeMap;
    }

    public constructor() {
    }
}
